import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum LOGIN_FORM_FIELDS {
  EMAIL = 'email',
  PASSWORD = 'password',
}

export enum LOGIN_FORM_FIELDS_NAMES {
  EMAIL = 'LOGIN.EMAIL',
  PASSWORD = 'LOGIN.PASSWORD',
}

export type LoginFieldTypes = {
  [LOGIN_FORM_FIELDS.EMAIL]: string;
  [LOGIN_FORM_FIELDS.PASSWORD]: string;
}

export type LoginFieldsReturnTypes = {
  email: string;
  password: string;
}

export const loginInitialValues: LoginFieldTypes = {
  [LOGIN_FORM_FIELDS.EMAIL]: '',
  [LOGIN_FORM_FIELDS.PASSWORD]: '',
};


export const getLoginValidationSchema = (t: TFunction): Yup.SchemaOf<LoginFieldTypes> => Yup.object<Shape<LoginFieldTypes>>().shape({
  [LOGIN_FORM_FIELDS.EMAIL]: Yup.string()
    .email(t('LOGIN.EMAIL_VALIDATION_CONDITION1'))
    .min(5, t('LOGIN.EMAIL_VALIDATION_CONDITION2'))
    .max(50, t('LOGIN.EMAIL_VALIDATION_CONDITION3'))
    .required(t('LOGIN.EMAIL_REQUIRED')),
  [LOGIN_FORM_FIELDS.PASSWORD]: Yup.string()
    .min(3, t('LOGIN.PASSWORD_VALIDATION_CONDITION1'))
    .max(50, t('LOGIN.PASSWORD_VALIDATION_CONDITION2'))
    .required(t('LOGIN.PASSWORD_REQUIRED'))
});
